//#region page-template/offers-clickout/OffersClickoutGuard.tsx
var e = [
	"clickoutService",
	"clickoutServiceUrl",
	"deviceType",
	"fullPageUrl",
	"pageUrl"
], t = (e) => typeof e == "string" && e.trim().length > 0, n = (e) => typeof e == "string" && (e.includes("undefined") || e.includes("null")), r = (r) => {
	let i = [];
	for (let n of e) t(r[n]) || i.push(`missing or empty "${n}"`);
	return typeof r.gtmId != "string" && i.push("missing \"gtmId\""), n(r.clickoutServiceUrl) && i.push(`malformed "clickoutServiceUrl" (${String(r.clickoutServiceUrl)})`), i;
}, i = (e, t) => {
	let n = r(t);
	if (n.length === 0) return;
	let i = `[${e}] Offers clickout props are not wired up correctly: ${n.join(", ")}. These props must be injected by the renderer (page-template componentMap or GridGroupOffers).`;
	throw console.error(i, t), Error(i);
}, a = ({ children: e, componentName: t, values: n }) => (i(t, n), e), o = ({ clickoutUrl: e, currentPathWithRepub: t, deviceType: n, fullPageUrl: r, gtmId: i }) => ({
	clickoutService: "OFFERS_CLICKOUT_SERVICE",
	clickoutServiceUrl: `${e}/offer/clickout`,
	pageUrl: t,
	deviceType: n,
	gtmId: i,
	fullPageUrl: r
});
//#endregion
export { a as OffersClickoutGuard, i as assertOffersClickoutProps, r as getOffersClickoutProblems, o as getOffersClickoutServiceProps };
